"use client"

import { useEffect, useState, useMemo } from "react"
import "./styles/product_details_page.css"
import Loader from "../../components/loader/loader"
import ProductCard from "./Productcard"
import MiniCart from "./Minicart"
import { stringToTitleCase } from "../../utils/helper"
import { LocalStorageUtils } from "../../utils/localstorage.utils.jsx"
import { EVENT_NAME, PRODUCT } from "utils/constants"
import CommonProductCard from "./CommonProductCard"
import debounce from "lodash.debounce"
import AnalyticsService from "services/analytics.service"

export default function ProductListDisplay({ products, displayName, isLoading, isRepairPage = false }) {
  const [cart, setCart] = useState({})
  const [isInitialLoad, setIsInitialLoad] = useState(true)
  const [searchQuery, setSearchQuery] = useState("")

  useEffect(() => {
    const storedCart = LocalStorageUtils.getCart()
    setCart(storedCart)
    setIsInitialLoad(false)
  }, [])

  useEffect(() => {
    if (!isInitialLoad) {
      LocalStorageUtils.setCart(cart)
    }
  }, [cart, isInitialLoad])

  useEffect(() => {
    const interval = setInterval(() => {
      LocalStorageUtils.removeCart()
      setCart({})
    }, 600000)
    return () => clearInterval(interval)
  }, [])

  const clearFromCart = (productId) => {
    setCart((prevCart) => {
      const updatedCart = { ...prevCart }
      delete updatedCart[productId]
      return updatedCart
    })
  }

  // Filter products based on search query
  const filteredProducts = products.filter((product) => product.name.toLowerCase().includes(searchQuery.toLowerCase()))

  const searchQueryChange = (e) => {
    const searchQueryText = e.target.value
    setSearchQuery(searchQueryText)
    AnalyticsService.trackEvent(EVENT_NAME.SEARCH_PRODUCT, {
      searchQuery: searchQueryText,
    })
  }

  const debouncedResults = useMemo(() => {
    return debounce(searchQueryChange, 300)
  }, [])

  // Calculate total items in cart
  const cartItemCount = Object.keys(cart).reduce((total, productId) => total + cart[productId].quantity, 0)

  return (
    <>
      {isLoading ? (
        <div className="product_details_page_loader_container">
          <Loader />
        </div>
      ) : (
        <div className="product_details_page_container">
          <div className="product_details_page_header">
            <h1 className="product_details_page_title">{stringToTitleCase(displayName)}</h1>
          </div>

          <div className="product_details_page_search_container">
            <input
              type="text"
              placeholder="Search for products..."
              onChange={debouncedResults}
              className="product_details_page_search_input"
            />
          </div>

          <div className="product_details_page_product_grid">
            {filteredProducts.length === 0 ? (
              <div className="product_details_page_no_products">No products found matching your search</div>
            ) : (
              filteredProducts.map((product) =>
                product.type === PRODUCT.TYPE.COMMON_PRODUCT ? (
                  <CommonProductCard
                    key={product.id}
                    commonProduct={product}
                    cart={cart}
                    setCart={setCart}
                    clearFromCart={clearFromCart}
                    isRepairPage={isRepairPage}
                  />
                ) : (
                  <ProductCard
                    key={product.id}
                    product={product}
                    cart={cart}
                    setCart={setCart}
                    clearFromCart={clearFromCart}
                    isRepairPage={isRepairPage}
                  />
                ),
              )
            )}
          </div>

          {/* Mini Cart Popup */}
          <MiniCart cart={cart} setCart={setCart} clearFromCart={clearFromCart} isRepairPage={isRepairPage} />
        </div>
      )}
    </>
  )
}
